import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AngularFireStorage } from '@angular/fire/compat/storage';
import { MatDialog } from '@angular/material/dialog';
import { PdfModalComponent } from '@components/pdf-modal/pdf-modal.component';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { MatterUploadedFilesSelectors } from '@state/matter/uploaded-files/matter-uploaded-files.selectors';

@UntilDestroy()
@Component({
	selector: 'app-closer-sync-lender-docs',
	templateUrl: './closer-sync-lender-docs.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class CloserSyncLenderDocsComponent {
	@Select(MatterUploadedFilesSelectors.getUploadedFilesBySource('lender'))
	lenderDocs$;

	constructor(
		private matDialog: MatDialog,
		private analytics: AnalyticsService,
		private storage: AngularFireStorage,
	) {}

	openPDF(file) {
		this.analytics.logEvent(AnalyticsEvent.SYNC_MORTGAGE_PAGE_INSTRUCTIONS);
		const ref = this.storage.ref(file.url);
		ref
			.getDownloadURL()
			.pipe(untilDestroyed(this))
			.subscribe((url) => {
				window.open(url, '_blank');
			});
	}
}
